import reducer from "./reducers";

import * as listadosOps from "./operations";
import * as listadosTypes from "./types";

export { listadosOps, listadosTypes };

export default reducer;



// WEBPACK FOOTER //
// ./src/ducks/listados/index.js